import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-151ee01d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auxbanner" }
const _hoisted_2 = {
  key: 0,
  class: "noUserTasks"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Brukeren har ingen prosjekter", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Flytt bruker")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Flytt bruker med alle prosjekter")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Flytt alle prosjekter")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "projectTitle" }, "Brukerens prosjekter:", -1))
const _hoisted_11 = {
  key: 1,
  class: "moveTask"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Flytt")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Løpenummer ")

import { computed, ComputedRef, onBeforeMount, reactive, ref } from 'vue';
import { AuxCard, AuxButton, AuxSpinner, AuxBanner } from '@ambita/design-system';
import APIServices from '@/services/apiFetch';
import { UserType } from '@/typings/User/user';
import { useRoute } from 'vue-router';
import UserInfo from '@/components/Cards/UserCard/UserInfo.vue';
import { RouterService } from '@/router';
import { TaskTypes } from '@/typings/task/task';
import { Common } from '@/typings/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCard',
  setup(__props) {

const route = useRoute();
let isLoading = ref<boolean>(true);
const banner = reactive<Common.Banner>({
  type: '',
  message: '',
  showBanner: false,
});

const moveUserView = ref<boolean>(false);

let user = ref<UserType.User | null>();
let tasks = ref<TaskTypes.Task[]>([]);
const filterQuery = ref<string>('');

onBeforeMount(async () => {
  user.value = await APIServices.fetchUserById(route?.params?.guid);
  tasks.value = user.value.tasks;
  isLoading.value = false;
});

const filterTasks: ComputedRef<TaskTypes.Task[]> = computed(() => {
  let userFilter = new RegExp(filterQuery.value, 'i');
  return tasks.value.filter((el: TaskTypes.Task) => el.taskId.toString().match(userFilter));
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AuxBanner), {
        type: banner.type
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(banner.message), 1)
        ]),
        _: 1
      }, 8, ["type"])
    ], 512), [
      [_vShow, banner.showBanner]
    ]),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(_unref(AuxSpinner), {
          key: 0,
          class: "spinner"
        }))
      : (_openBlock(), _createBlock(_unref(AuxCard), {
          key: 1,
          class: "userCardContent"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(UserInfo, { user: _unref(user) }, null, 8, ["user"]),
              (_unref(user)?.tasks?.length <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                : _createCommentVNode("", true),
              (_unref(user)?.tasks?.length <= 0 && !moveUserView.value)
                ? (_openBlock(), _createBlock(_unref(AuxButton), {
                    key: 1,
                    primary: false,
                    size: "small",
                    class: "btn",
                    id: "moveUserBtn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _unref(RouterService).routeTo('MoveUser', {
            guid: _unref(user)?.guid,
          })
        ))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(user)?.tasks?.length)
                ? (_openBlock(), _createBlock(_unref(AuxButton), {
                    key: 2,
                    primary: false,
                    size: "small",
                    class: "btn",
                    id: "moveUserBtn",
                    onClick: _cache[1] || (_cache[1] = 
          () =>
            _unref(RouterService).routeTo('MoveUser', {
              guid: _unref(user)?.guid,
            })
        )
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(user)?.tasks?.length > 0 && !moveUserView.value)
                ? (_openBlock(), _createBlock(_unref(AuxButton), {
                    key: 3,
                    primary: false,
                    size: "small",
                    class: "moveAllBtn",
                    onClick: _cache[2] || (_cache[2] = 
          () =>
            _unref(RouterService).routeTo('Tasks', {
              guid: _unref(user)?.guid,
            })
        )
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_8
            ]),
            _createElementVNode("div", null, [
              (_unref(tasks)?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      class: "searchProject",
                      type: "text",
                      placeholder: "Søk løpenr...",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterQuery).value = $event))
                    }, null, 512), [
                      [_vModelText, filterQuery.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(tasks)?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterTasks), (task) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: task?.taskId
                      }, [
                        _createVNode(_unref(AuxButton), {
                          primary: false,
                          size: "small",
                          class: "moveBtn",
                          onClick: 
              () =>
                _unref(RouterService).routeTo('Task', {
                  taskId: task.taskId.toString(),
                })
            
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _hoisted_13,
                        _createVNode(_component_router_link, {
                          to: { name: 'Task', params: { taskId: task.taskId.toString() } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(task?.taskId), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createTextVNode(" : " + _toDisplayString(task?.projectName), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
  ], 64))
}
}

})